export default __webpack_public_path__ + "static/media/logo_hub.c9f06c12.png";